import script from "./popupMessimage.vue?vue&type=script&setup=true&lang=js"
export * from "./popupMessimage.vue?vue&type=script&setup=true&lang=js"

import "./popupMessimage.vue?vue&type=style&index=0&id=53f47565&lang=scss"

const __exports__ = script;

export default __exports__